export default class LoginForm {}

const selectors = {
  hideRecover: "[data-hide-recover]",
  login: "[data-login]",
  recover: "[data-recover]",
  recoverFeedback: "[data-recover-feedback]",
  recoverLink: "[data-recover-link]",
};

const activeClass = "is-hidden";
const login = document.querySelector(selectors.login);

if (login) {
  const recoverLink = login.querySelector(selectors.recoverLink);

  if (recoverLink) {
    recoverLink.addEventListener("click", handleRecoverForm);
  }
}

const recover = document.querySelector(selectors.recover);
const hideRecover = document.querySelector(selectors.hideRecover);

const shouldShowRecover = () =>
  window.location.hash === "#recover" ||
  (recover !== null &&
    recover.querySelector(selectors.recoverFeedback) !== null);

function handleRecoverForm(event: Event) {
  event.preventDefault();
  toggleRecoverForm();
}

function toggleRecoverForm() {
  if (!login || !recover) {
    return;
  }

  login.classList.toggle(activeClass);
  recover.classList.toggle(activeClass);
}

function init() {
  if (!recover) {
    return;
  }

  if (shouldShowRecover()) {
    toggleRecoverForm();
  }

  if (hideRecover) {
    hideRecover.addEventListener("click", handleRecoverForm);
  }
}

init();
